/* eslint-disable react/prop-types */
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import ReasonField from './ReasonField'

function TenantListDialog({
  open,
  featureName,
  tenantListInput,
  reason,
  onTenantListInputChange,
  onReasonChange,
  onCancel,
  onSubmit,
}) {
  const disabled = tenantListInput.trim() === '' || reason.trim() === ''

  return (
    <Dialog open={open} onClose={onCancel} fullWidth maxWidth="sm">
      <DialogTitle>Adicionar lista de tenants: {featureName}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Informe uma <b>lista de IDs de tenant</b>, separados por vírgula ou por linha.
        </DialogContentText>
        <TextField
          label="Lista de IDs de tenant"
          value={tenantListInput}
          onChange={(event) => onTenantListInputChange(event.target.value)}
          fullWidth
          multiline
          minRows={3}
          margin="normal"
          placeholder={'123456789, 987654321\nou um por linha'}
        />
        <ReasonField value={reason} onChange={onReasonChange} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancelar</Button>
        <Button variant="contained" disabled={disabled} onClick={onSubmit}>
          Adicionar lista
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default TenantListDialog
